var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.textAvatar)?_c('div',{staticClass:"video-avatar",style:(_vm.avatarStyle)},[_vm._v(" "+_vm._s(_vm.textAvatar)+" ")]):_c('Avatar',{staticClass:"video-avatar",style:(_vm.avatarStyle),attrs:{"src":"avatar"}})
}
var staticRenderFns = []

export { render, staticRenderFns }